import { render, staticRenderFns } from "./indexOverview.vue?vue&type=template&id=3da145e5&scoped=true"
import script from "./indexOverview.vue?vue&type=script&lang=js"
export * from "./indexOverview.vue?vue&type=script&lang=js"
import style0 from "./indexOverview.vue?vue&type=style&index=0&id=3da145e5&prod&lang=scss&scoped=true"
import style1 from "./indexOverview.vue?vue&type=style&index=1&id=3da145e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da145e5",
  null
  
)

export default component.exports